define( [
	"./arr"
], function( arr ) {

"use strict";

return arr.splice;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/splice.js
// module id = 1827
// module chunks = 0